module.exports = __webpack_public_path__ + "assets/img/introduction_culture_bg.1225a4d1.png";